<template>
    <div class="mt-16 px-6 h-full flex flex-col">
        <h2 class="text-2xl font-bold">{{ t('free_space_header') }}</h2>
        <p v-if="type == 'dangerous_trash' && client == 'nordvaerk'" class="mt-6 text-base">{{ t('free_space_text') }}</p>
        <p v-else class="mt-6 text-base">{{ t('free_space_text_textile') }}</p>
        <div v-if="type == 'dangerous_trash' || type == 'textile'" class="max-w-lg mx-auto w-full pt-4 pb-6">
            <Button @click="confirmFreeSpace('over')" class="mt-16 text-center" :text="t('over_50')"></Button>
            <Button @click="confirmFreeSpace('under')" class="mt-2 text-center" :text="t('under_50')"></Button>
        </div>
        <div v-if="type == 'bag'" class="max-w-lg mx-auto w-full pt-4 pb-6">
            <Button @click="confirmFreeSpace('over')" class="mt-16 text-center" :text="t('less_that_5_black')"></Button>
            <Button @click="confirmFreeSpace('over')" class="mt-2 text-center" :text="t('less_than_5_green')"></Button>
            <Button @click="confirmFreeSpace('over')" class="mt-2 text-center" :text="t('no_bags_left')"></Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    const { t } = useI18n()
    const emit = defineEmits(["update:modelValue"]);
    const props = defineProps<{
        type: string;
        client: string;
    }>();

    function confirmFreeSpace(type: string) {
        if (type === 'over') {
            emit("update:modelValue", true);
        } else {
            emit("update:modelValue", false);
        }
    }

</script>